var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHandling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.13,
    height: 19.13,
    viewBox: "0 0 19.13 19.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7410",
    "data-name": "Path 7410",
    d: "M295.686,13.812a9.565,9.565,0,1,0,9.565,9.565,9.565,9.565,0,0,0-9.565-9.565m-.068,2.537c5.947,0,6.331,5.153,6.331,5.153H289.342c.666-5.153,6.276-5.153,6.276-5.153m-1.132,14.056c-5.422-.66-5.788-6.741-5.788-6.741,6.667.952,5.788,6.741,5.788,6.741m1.366-5.258a1.328,1.328,0,1,1,1.328-1.328,1.328,1.328,0,0,1-1.328,1.328m1.052,5.258s-.659-5.5,5.935-6.741c0,0,.22,5.935-5.935,6.741",
    transform: "translate(-286.121 -13.812)",
    fill: "#2e117f"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandling);
export default __webpack_public_path__ + "static/media/handling.83df7d21ba19b2903e36c657c651fb46.svg";
export { ForwardRef as ReactComponent };